/**
 * @file 加载提示动画
 * @author lupengyu@bytedance.com
 */

import React from 'react';
import './index.less';

export default function Loading() {
  return (
    <div styleName="mask">
      <div styleName="loading">Loading...</div>
    </div>
  );
}
